import React from 'react';
import PropTypes from "prop-types";

import './statisticUsers.less';

const StatisticUsers = ({ statisticUsers }) => {
  const { users, usersCount, contributorsCount } = statisticUsers;
  const onDownloadList = () => {
    let emailsListString = users && users.map((user) => {
      return (`<w:p><w:pPr/><w:r><w:rPr><w:rFonts w:ascii="Helvetica" w:h-ansi="Helvetica" w:cs="Helvetica"/><wx:font wx:val="Helvetica"/><w:sz w:val="24"/><w:sz-cs w:val="24"/></w:rPr>
        <w:t>${user.email}</w:t></w:r></w:p>`)
    });

    let xmlText = `<?xml version="1.0" encoding="UTF-8"?> <?mso-application progid="Word.Document"?>
      <w:wordDocument xmlns:w="http://schemas.microsoft.com/office/word/2003/wordml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w10="urn:schemas-microsoft-com:office:word" xmlns:sl="http://schemas.microsoft.com/schemaLibrary/2003/core" xmlns:aml="http://schemas.microsoft.com/aml/2001/core" xmlns:wx="http://schemas.microsoft.com/office/word/2003/auxHint" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:dt="uuid:C2F41010-65B3-11d1-A29F-00AA00C14882" w:macrosPresent="no" w:embeddedObjPresent="no" w:ocxPresent="no" xml:space="preserve">
      <o:DocumentProperties/>
      <w:fonts>
      <w:defaultFonts w:ascii="Times New Roman" w:fareast="Times New Roman" w:h-ansi="Times New Roman" w:cs="Times New Roman"/>
      </w:fonts>
      <w:docPr/>
      <w:body>
      <wx:sect>
      ${emailsListString}
      <w:sectPr>
      <w:pgSz w:w="11900" w:h="16840"/>
      <w:pgMar w:top="1440" w:rigw:pht="1440" w:bottom="1440" w:left="1440"/>
      </w:sectPr>
      </wx:sect>
      </w:body>
      </w:wordDocument>`;

    const filename = "Emails-list.xml";
    const pom = document.createElement('a');
    const bb = new Blob([xmlText], {type: 'text/plain'});

    pom.setAttribute('href', window.URL.createObjectURL(bb));
    pom.setAttribute('download', filename);

    pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
    pom.draggable = true;
    pom.classList.add('dragout');

    pom.click();
  };

  return (
    <div className="statistic-users">
      <h3>Statistic for users</h3>
      <p>Total count users: <span>{usersCount}</span></p>
      <p>Total count contributors: <span>{contributorsCount}</span></p>
      <div className="user-list">
        <h2>Users list:</h2>
        <div className="emails-list-wr">
          <div className="emails-list-header">
            <p>User name </p>
            <div className="download-button-wr">
              <span className="download-button" onClick={() => onDownloadList()}> Download List</span>
              <p>
                <span>Email</span>
              </p>
            </div>
          </div>
          <div className="emails-list">
            {
              users && users.map((user, i) => (
                <p key={`${user.email}-${i}`}>{user.name || 'NoName'}: <span>{user.email || 'NoEmail'}</span></p>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  )
};

StatisticUsers.propTypes = {
  statisticChat: PropTypes.object
};

export default StatisticUsers;



// WEBPACK FOOTER //
// ./src/components/Modules/Statistics/StatisticUsers/StatisticUsers.js